import { Icon, IconProps } from '@elkaso-app/web-design';

export const OrdersIcons = (props: IconProps) => {
  return (
    <Icon width='22px' height='22px' viewBox='0 0 24 24' fill='#757575' {...props}>
      <path
        d='M7 17C5.9 17 5.01 17.9 5.01 19C5.01 20.1 5.9 21 7 21C8.1 21 9 20.1 9 19C9 17.9 8.1 17 7 17ZM1 1V3H3L6.6 10.59L5.25 13.04C5.09 13.32 5 13.65 5 14C5 15.1 5.9 16 7 16H19V14H7.42C7.28 14 7.17 13.89 7.17 13.75L7.2 13.63L8.1 12H15.55C16.3 12 16.96 11.59 17.3 10.97L20.88 4.48C20.9625 4.32739 21.004 4.15598 21.0005 3.98253C20.9969 3.80908 20.9485 3.63951 20.8598 3.49039C20.7711 3.34127 20.6453 3.2177 20.4946 3.13175C20.3439 3.04579 20.1735 3.0004 20 3H5.21L4.27 1H1ZM17 17C15.9 17 15.01 17.9 15.01 19C15.01 20.1 15.9 21 17 21C18.1 21 19 20.1 19 19C19 17.9 18.1 17 17 17Z'
        fill='inherit'
      />
    </Icon>
  );
};
